import React, { useState, useEffect }from 'react';

import PropTypes from 'prop-types';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import GroupsService from "../../services/groups.service";

import '../../styles/style.scss';
import '../../styles/createRolStyle.scss';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  TextField,
  Typography,
  FormControl,
  MenuItem,
} from '@material-ui/core';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import Swal from 'sweetalert2';
import { actionErrorConnection } from '../../constants/component/actionErrorConnection';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import {CustomCheckbox} from '../../constants/customComponent/CustomCheckbox'
import rolesService from '../../services/roles.service';
import usersService from '../../services/users.service';
import { viewsList } from '../../constants/models/viewsList';
import { ADMINISTRADOR, GERENTE } from '../../constants/models/typeOperationRol';
import { useAuthInfo } from '../../utils/authUtils';

export const CreateGroupScreen = (props) => {

  const {noCustomer, idCustomer, operationRol} = useAuthInfo();

  const dispatch = useDispatch();
  const history = useHistory();

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const groupUpdate = props.match.params.id;

  const initialState = {
    id:null,
    name: '',
    status: true,
    manager: '',
    permission:[],
    customers:[]
  }

  const [groupList, setGroupList] = useState([]);
  const [isloadDataGroup, setIsLoadDataGroup] = useState(false);
  const [isloadDataPermission, setIsLoadDataPermission] = useState(false);
  const [permissionsList, setPermissionsList] = useState([]);
  const [accessRoles, setAccessRoles] = useState([]);
  const [managersList, setManagersList] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  const [rolResponse, setRolResponse] = useState(initialState);
  const [statusGroup, setStatusGroup] = useState(true);
  const [checkedCustomers, setCheckedCustomers] = useState(initialState.customers);
  const [checkedPermissions, setCheckedPermissions] = useState(initialState.permission);
  const [isDisabled, setDisabled] = useState(false);

  const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nombre del grupo es requerido').matches(/^[A-z0-9]+$/, 'Solo se admiten mayusculas y números')
    .test('','Ya se encuentra registrado un grupo con el mismo nombre',data=>{
      if(groupUpdate){
        if(rolResponse.nameGroup === data){ 
          return true
        }else{ 
          return (groupList.filter(({nameGroup})=> nameGroup === data)?.length < 1)
        }
    }else{
      return (groupList.filter(({nameGroup})=> nameGroup === data)?.length < 1)
    }}),
    manager: Yup.string().required('Representante requerido'),
    permission: Yup.array().required('Permisos requeridos').test('','Seleccionar por lo menos un rol',()=> checkedPermissions.length > 0),
    customers: Yup.array().required('Sucursal requerida')
    .test('','Seleccionar por lo menos una sucursal',()=> checkedCustomers.length > 0)
    .test('','El representante no se puede agregar como sucursal',()=> checkedCustomers.findIndex((customer)=>customer === rolResponse.manager) !== 0)
  });

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: rolResponse
  });

  useEffect(() => {
      let accessArray = [];
      viewsList.forEach((dataPermissions)=>{
        if(dataPermissions.showContent){
          accessArray.push(dataPermissions.name);
        }
      })
     
      setAccessRoles(accessArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
      getPermissions();
      getManagers();
      getUsers();
      getGroups();
      if(groupUpdate){
        getGroup(groupUpdate);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupUpdate]);
  
  /** 
   * Recupera la lista de grupos creados
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
  */
  const getGroups = () => {

    setGroupList([]);
    GroupsService.getAllGroupsByCustomer(noCustomer)
      .then((response) => {
        setGroupList(response);
      })
      .catch((error) => {
        console.log(error)
        //validación realizada porque en firefox cancela la operación al hacer el render de la aplicación
        if(error.message === 'Request aborted'){
          return;
        }
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
          actionErrorConnection(error, 'Error al recuperar lista de grupos.');
      }
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al recuperar lista de grupos. Intente más tarde.',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
        }).then(()=>{
          props.history.push('/administration/groups');
        window.location.reload();
        })
      });
  };

  /** 
   * Recupera la información del rol para precargar el formulario de actualización
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
  */
  const handleGroupResponse = (response) => {
    const initCheckedCustomers = [];
    let checkedPermissions = [];
    viewsList.forEach(({ name, permissions }) => {
      let valueSearchCount = 0;
      for (const permission of permissions) {
        const valueFilter = response?.permission.filter((data) => data.name === permission);
        if (valueFilter.length > 0) {
          valueSearchCount = valueSearchCount + 1;
        }
      }
      if (valueSearchCount === permissions.length) {
        checkedPermissions.push(name);
      }
    });

    response.employess?.forEach(({ id }) => {
      initCheckedCustomers.push(id);
    });

    const groupInitValuesResponse = {
      ...response,
      name: response.nameGroup,
      manager: response.manager.id,
      customers: initCheckedCustomers,
      permission: checkedPermissions,
      managerInit: response.manager,
    };
    setCheckedCustomers(initCheckedCustomers);
    setCheckedPermissions(checkedPermissions);
    setStatusGroup(response.status);
    setRolResponse(groupInitValuesResponse);
    reset(groupInitValuesResponse);
    setIsLoadDataGroup(false);
  };

  const handleGroupError = (error) => {
    if (error.message === 'Request aborted') {
      return;
    }
    setIsLoadDataGroup(false);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Error al recuperar información del grupo. Intente más tarde.',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
    }).then(() => {
      props.history.push('/administration/groups');
      window.location.reload();
    });
  };

  const getGroup = (idRol) => {
    setIsLoadDataGroup(true);
    GroupsService.getGroupById(idRol)
      .then(handleGroupResponse)
      .catch(handleGroupError);
  }

  /** 
   * Recupera lista de permisos del sistema
   * @author alSanchez - ETE
   * @version 1.0.0 - Septiembre 2023
   * 
  */
  const getPermissions = () => {
    setIsLoadDataPermission(true);
    rolesService.getPermissionsList().then(
      (response) => {
        setIsLoadDataPermission(false);
        setPermissionsList(response);
      }).catch((error)=>{
        if(error.message === 'Request aborted'){
          return;
        }
        setIsLoadDataPermission(false);
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
          actionErrorConnection(error, 'Error al recuperar permisos.');
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al recuperar lista de permisos. Intente más tarde.',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
      }).then(()=>{
        props.history.push('/administration/groups');
      window.location.reload();
      })
    })
  }

  /** 
   * Recupera lista de managers
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   * 
  */
  const getManagers = () => {
    usersService.getManagersByAN8(noCustomer).then(
      (response) => {
        setManagersList(response);
      }).catch((error)=>{
        if(error.message === 'Request aborted'){
          return;
        }
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
          actionErrorConnection(error, 'Error al recuperar representantes.');
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al recuperar lista de representantes. Intente más tarde.',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
      }).then(()=>{
        props.history.push('/administration/groups');
      window.location.reload();
      })
    })
  }

  /** 
   * Recupera lista de usuarios con AN8
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   * 
  */
  const getUsers = () => {
    usersService.getCustomersByAN8(noCustomer).then(
      (response) => {
        setCustomersList(response);
      }).catch((error)=>{
        if(error.message === 'Request aborted'){
          return;
        }
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
          actionErrorConnection(error, 'Error al recuperar sucursales.');
      }
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al recuperar lista de sucursales. Intente más tarde.',
        showConfirmButton: true,
        confirmButtonText: 'Aceptar',
      }).then(()=>{
        props.history.push('/administration/groups');
      window.location.reload();
      })
    })
  }

  /**
   * Cambia el estado del checkbox por medio de su id
   * @param {*} checkedId - identificador del checkbox que cambiara de estado
   * @returns { array } arreglo con los checkbox activos
   * @author alSanchez - ETE
    * @version 1.0.0 - Noviembre 2023
  */
  const handleSelectPermissions = (checkedId) => {
    const newIds = checkedPermissions?.includes(checkedId)
      ? checkedPermissions?.filter(name => name !== checkedId)
      : [...(checkedPermissions ?? []), checkedId];
    setCheckedPermissions(newIds);
    console.log("new ids", newIds)
    return newIds;
  }

  /**
   * Cambia lista de usuarios seleccionedos
   * @param {*} checkedId - identificador del checkbox que cambiara lista de usuarios
   * @returns { array } arreglo con los checkbox activos
   * @author alSanchez - ETE
    * @version 1.0.0 - Octubre 2023
   */
  const handleSelectCustomers = (checkedId) => {
    const newIds = checkedCustomers?.includes(checkedId)
      ? checkedCustomers?.filter(name => name !== checkedId)
      : [...(checkedCustomers ?? []), checkedId];
    setCheckedCustomers(newIds);
    return newIds;
  }

  /**
   * Cambia los datos del formulario de acuerdo a la entrada seleccionada
   * @param {*} event - recupera información del imput seleccionado
   * @param {string} input - nombre de la entrada
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
  const handleChangeValue =(event, input) =>{
    let value = event.target.value;
    if(input === 'name'){
      value = value.toUpperCase();
    }
    setRolResponse({...rolResponse, [input]: value});
    reset({...rolResponse, [input]: value});
  }

  /**
   * Cambia el estado del swich para seleccionar si un esta activo
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
  const handleChangeStatusRol = () =>{
    setStatusGroup(!statusGroup);
  }

  /**
   * Cancela el llenado de información dentro del formulario y regresa a la pantalla de grupos
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
  const handleCancel = () => {
    swalCustomButtons.fire({
      title: 'Cancelar',
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        props.history.push('/administration/groups');
        window.location.reload();
      }
    })
  }

  /**
   * Envia el formulario de creación / actualización de grupos
   * @param {*} data - informacion del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const onSubmit = (data) => {
    setDisabled(true);
    let customersActived = [];
    let permissionsActived = [];
    let permissionsArray = [];

    checkedPermissions.forEach(permissionActived=>{
      const permissionsFind =  viewsList.find(({name})=>name=== permissionActived).permissions;
      permissionsFind.forEach(data=>{
        permissionsActived.push(data);
      })
    })
    permissionsActived = [...new Set(permissionsActived)];
    permissionsActived.forEach((permissionActived)=>{
      
      const permissionSelect = permissionsList.find(access=>access.name === permissionActived);
      if(permissionSelect){
        permissionsArray.push(permissionSelect)
      }
    })

    checkedCustomers.forEach(customer=>{
      const customerSelect = customersList.find(({id})=> id === customer);
      if(customerSelect){
        customersActived.push({
          id: customerSelect.id
        })
      }
    })

    let groupDataToSend = {
      id: data.id,
      name: data.name,
      status: statusGroup,
      idManager: data.manager ? Number(data.manager) : data.manager,
      permission: permissionsArray,
      empleados: customersActived
    }
    console.log("data to send", groupDataToSend)
    if(groupUpdate){
      groupDataToSend = {
        ...groupDataToSend,
        idAdministrator: rolResponse.idAdministrator
        
      }
    } else {
      groupDataToSend = {
        ...groupDataToSend,
        idAdministrator: idCustomer
      }
    }

    console.log(groupDataToSend);

    if(groupUpdate){
      updateGroup(groupDataToSend, groupDataToSend.id);
    }else{
      createGroup(groupDataToSend);
    }
  };

  /**
   * solicita la creación de un rol
   * @param {*} dataRol - informacion del formulario
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
  const createGroup = (rolData) =>{
    GroupsService.createGroup(rolData).then(()=>{
      setDisabled(false);
      Swal.fire({
        icon: 'success',
        title: 'Grupo creado correctamente',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then(() => {
        props.history.push('/administration/groups');
        window.location.reload();
      });    
    }).catch((error)=>{
      setDisabled(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al crear grupo');
        }
    });
  }

  /**
   * Solicita la actualización de un rol
   * @param {*} dataRol - informacion del formulario
   * * @param {number} idRol - identificador del rol
   * @author alSanchez - ETE
   * @version 1.0.0 - Octubre 2023
   */
  const updateGroup = (dataRol, idRol) =>{
    GroupsService.updateGroup(dataRol, idRol).then(()=>{
      setDisabled(false);
      Swal.fire({
        icon: 'success',
        title: 'Grupo actualizado correctamente',
        showConfirmButton: true,
        confirmButtonText: 'Regresar'
      })
      .then(() => {
        props.history.push('/administration/groups');
        window.location.reload();
      });    
    }).catch((error)=>{
      setDisabled(false);
      if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al actualizar grupo');
        }
    });
  }

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                      <span>Grupos </span>
                      <i className="fas fa-angle-right ms-2 me-2"></i>
                      <span>{groupUpdate ? 'Actualizar grupo' : 'Nuevo grupo'}</span>
                    </div>
                    <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                      <form>
                        <div className="container p-0">
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Información general</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                <div className="col-md-6 mt-2 mb-2">
                                  <TextField
                                    required
                                    className="w-100"
                                    id="name"
                                    name="name"
                                    label="Nombre del grupo"
                                    type="text"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    value={rolResponse.name}
                                    {...register('name')}
                                    onChange={event => handleChangeValue(event, 'name')}
                                    error={!!errors?.name}
                                  />
                                  <Typography variant="inherit" color="error">
                                      {errors.name?.message}
                                  </Typography>
                                </div>
                                <div className="col-md-12 mt-2 mb-2">
                                <FormControlLabel
                                      control={
                                        <CustomCheckbox
                                          onChange={() => handleChangeStatusRol()}
                                          checked={statusGroup}
                                        />
                                      }
                                      label={
                                        <span className="checkbox-text">Grupo activo</span>
                                      }
                                    />
                                </div>
                              </div> 
                            </div>
                          </div>
                          {isloadDataGroup && <div><i className="fas fa-spinner fa-spin ms-2"></i></div>}
                          <div className="row ">
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle" >Asignar representante</span>
                              </div>
                            </div>
                            <div className="col-md-9 pt-5 pb-2">
                              <div className="row">
                                {
                                  groupUpdate && operationRol === GERENTE ? 
                                  <div className="col-md-6 mt-2 mb-2">
                                    <TextField
                                      className="w-100"
                                      id="managerUpdate"
                                      name="managerUpdate"
                                      label="Representante"
                                      type="text"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      disabled
                                      value={rolResponse.managerInit?.name}
                                    />
                                    <Typography variant="inherit" color="error">
                                        {errors.manager?.message}
                                    </Typography>
                                  </div>
                                  :
                                  <div className="col-md-6 mt-2 mb-2">
                                    <TextField
                                      select
                                      required
                                      className="w-100"
                                      id="manager"
                                      name="manager"
                                      label="Representante"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      disabled={operationRol !== ADMINISTRADOR}
                                      value={rolResponse.manager}
                                      {...register('manager')}
                                      onChange={event => handleChangeValue(event, 'manager')}
                                      error={!!errors.manager}
                                      >
                                          <MenuItem value="">Seleccionar representante</MenuItem>
                                      {managersList.map(({id, name}) => (
                                          <MenuItem key={`${noCustomer}-${id}-${Math.random()}`} value={id}>
                                          {name}
                                          </MenuItem>
                                      ))}
                                    </TextField>
                                    <Typography variant="inherit" color="error">
                                        {errors.manager?.message}
                                    </Typography>
                                  </div>
                                }
                              </div> 
                            </div>
                          </div>
                          <div className='row'>
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle">Asignar permisos</span>
                              </div>
                            </div>
                            {
                              isloadDataPermission ?
                              <div><i className="fas fa-spinner fa-spin ms-2"></i></div> :
                              <div className="col-md-9  pt-5">
                            <FormControl  className="w-100 container-checkbox-size" error={!!errors.permission?.message}>
                            
                            <div className="row w-100 ">
                            <Controller
                              id="permission"
                              name="permission"
                              render={({field:{onChange}}) =>
                                accessRoles.map((item) => (
                                  <div className="col-md-4" key={`${item}-permission-${Math.random()}`}>
                                    <FormControlLabel
                                      control={
                                        <CustomCheckbox
                                          onChange={() => onChange(handleSelectPermissions(item))}
                                          checked={checkedPermissions?.includes(item)}
                                        />
                                      }
                                      label={
                                        <span className="checkbox-text">{item}</span>
                                      }
                                    />
                                  </div>
                                ))
                              }
                              control={control}
                            />
                            </div>
                              </FormControl>
                              <Typography variant="inherit" color="error">
                                  {errors.permission?.message}
                              </Typography>
                            </div>
                            }
                          </div>
                          <div className='row'>
                            <div className="col-md-3">
                              <div className="border-text-menu-title">
                                <span className="text-subtitle">Asignar Sucursales</span>
                              </div>
                            </div>
                            {   
                              <div className="col-md-9  pt-5">
                            <FormControl  className="w-100 container-checkbox-size" error={!!errors.customers?.message}>
                            
                            <div className="row w-100 ">
                            <Controller
                              id="customers"
                              name="customers"
                              render={({field:{onChange}}) =>
                                customersList.map(({id, noCustomer, name}) => (
                                  <div className="col-md-6" key={`${name}-customer-${id}-${noCustomer}-${Math.random()}`}>
                                    <FormControlLabel
                                      control={
                                        <CustomCheckbox
                                          onChange={() => onChange(handleSelectCustomers(id))}
                                          checked={checkedCustomers?.includes(id)}
                                        />
                                      }
                                      label={
                                        <span className="checkbox-text"><strong>{noCustomer}</strong> - {name}</span>
                                      }
                                    />
                                  </div>
                                ))
                              }
                              control={control}
                            />
                            </div>
                              </FormControl>
                              <Typography variant="inherit" color="error">
                                  {errors.customers?.message}
                              </Typography>
                            </div>
                            }
                            
                          </div>
                          <div className="d-flex flex-row-reverse ">
                            <div className="col-md-9 d-flex flex-row-reverse border-button-actions mt-2 pt-2">
                              <button  
                              className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                              onClick={handleSubmit(onSubmit)}
                              disabled={ isDisabled }>
                                      {groupUpdate ? 'Actualizar' : 'Agregar'} { isDisabled && <i className="fas fa-spinner fa-spin"></i>}
                              </button>
                              <button  
                              className="btn custom-cancel-btn pt-2 pb-2 ps-3 pe-3 me-3"
                              type="button" 
                              onClick={handleCancel}>
                                    Cancelar
                              </button>
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                      
                    </div>

                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}

CreateGroupScreen.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }),
  history: PropTypes.object
}